import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TypeOptions, ClassOptions, RateOptions } from './activity-detail.enums';
import { ActivityDetailService } from './activity-detail.service';
import { BentoComboboxOptions } from '@bento/bento-ng';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ActivityCategoryService } from '@shared/services';
import { IActivityCategorySearch, IActivityCategoryDto } from '@shared/models';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-activity-detail',
	templateUrl: './activity-detail.component.html',
	styleUrls: ['./activity-detail.component.css']
})
export class ActivityDetailComponent implements OnInit, OnDestroy {
	TypeOptions = TypeOptions;
	ClassOptions = ClassOptions;
	RateOptions = RateOptions;

	// TODO: this is a mock data which should be updated after the service upgrade
	activityForm: FormGroup;
	classOptionsMock: any[] = [{
		id: 'billable',
		name: this.translate.instant('Core.Enums.ActivityClass.BILLABLE')
	}, {
		id: 'nonBillable',
		name: this.translate.instant('Core.Enums.ActivityClass.NONBILLABLE')
	}, {
		id: 'administrative',
		name: this.translate.instant('Core.Enums.ActivityClass.ADMINISTRATIVE')
	}];

	formSub: Subscription;
	surchargeOptions: BehaviorSubject<any[]>;
	comboboxOptions: BentoComboboxOptions = {
		searchable: true,
		searchCompare: (row, search) => {
			const searchLowerCase = search.toLocaleLowerCase();
			const name = `${row.name}`.toLowerCase();

			return name.indexOf(searchLowerCase) > -1 || row.id.toLocaleLowerCase().indexOf(searchLowerCase) > -1;
		},
		labelFormatter: row => row.name
	};
	activityCategoryDataStream: Observable<IActivityCategoryDto[]>;
	activityCategoryComboboxOptions: BentoComboboxOptions = {
		searchable: true,
		columns: [
			{
				name: 'code',
				width: '105px'
			},
			{
				name: 'invoiceDescription',
				width: '105px'
			}
		],
		headerTranslation: {
			code: 'ID',
			invoiceDescription: 'Name'
		},
		labelFormatter: row => [row.code, row.invoiceDescription].join(', ')
	};

	constructor(
		private formBuilder: FormBuilder,
		private activityCategoryService: ActivityCategoryService,
		public translate: TranslateService,
		public activityService: ActivityDetailService) { }

	ngOnInit(): void {
		this.activityForm = this.formBuilder.group({
			ID: ['', Validators.required],
			name: ['', Validators.required],
			activityStatus: ['active'],
			surchargeMethod: [null],
			fixedRate: [''],
			unitPrice: [''],
			unitCost: [''],
			typeOption: [TypeOptions.TIME],
			classOption: [ClassOptions.billable],
			rateOption: [RateOptions.NORATE],
		});
		this.upgradeSurchargeOptions();
		const activityCategorySearchParams: IActivityCategorySearch = {
			postData: {
				excludeCount: true,
				filterSearchSort: {
					orderBy: 'name',
					searchBy: 'code,name'
				},
				pagingDataRequest: {
					itemsPerPage: 20,
					pageIndex: 1
				}
			}
		};
		this.activityCategoryDataStream = this.activityCategoryService.postSearch(activityCategorySearchParams).pipe(
			map(data => data.items)
		);
	}

	get selectedActivityStatus() {
		return this.activityForm.get('activityStatus').value;
	}

	upgradeSurchargeOptions() {
		this.formSub = this.activityForm.get('typeOption').valueChanges.subscribe(() => {
			const options = this.activityService.getSurchargeOptions(this.optionForType);
			this.surchargeOptions = new BehaviorSubject(options);
		});
	}

	get optionForType() {
		return this.activityForm.get('typeOption').value;
	}

	get optionForClass() {
		return this.activityForm.get('classOption').value;
	}

	get optionForRate() {
		return this.activityForm.get('rateOption').value;
	}

	ngOnDestroy() {
		this.formSub.unsubscribe();
	}
}
